import { defineMessages } from 'react-intl';

// NOTE: Messages with "cancel" terminology intentionally use endDate as the placeholder value
// We only care to present users the date in which they can't use SS as opposed to telling them when they requested to cancel
const messages = defineMessages({
  trialExpiredTitle: {
    description: 'Title for info banner expired trial status',
    defaultMessage: '<b>Your Trial has Expired</b>',
    id: 'Tr9kuh',
  },
  pendingAccountCancel: {
    description: 'Title for info banner account, is cancelled but user still has access',
    defaultMessage: '<b>Account will be cancelled on {endDate}</b>',
    id: 'z7vta7',
  },
  accountCancelledTitle: {
    description: 'Title for cancelled account banner',
    defaultMessage: '<b>Account cancelled on {endDate}</b>',
    id: 'aI8DGJ',
  },
  trialExpiredMessage: {
    description: 'Info message for info banner expired trial status',
    defaultMessage:
      "Your progress has been saved and is still available. Select the plan that's right for you to pick up where you left off.",
    id: '1I/Zqt',
  },
  pendingAccountCancelMessage: {
    description: 'Info message for banner, account is cancelled but user still has access',
    defaultMessage:
      "We're sorry to see you go. If you'd like to continue with your ShipStation subscription, you can undo your cancel request at any time before {endDate}.",
    id: 'Oh0rrD',
  },
  accountCancelledMessage: {
    description: ' message for cancelled account banner',
    defaultMessage:
      "Your subscription was cancelled on {endDate} and your account is no longer active. If you'd like to continue using ShipStation, just choose <i>Renew Subscription</i> and select the plan that's right for you.",
    id: 'AmH/U7',
  },
  noValidPaymentMethod: {
    description: 'Info banner message for user letting them know they need to add a new form of payment',
    defaultMessage: 'There is no valid payment method for your subscription. Update or add payment method before {renewalDate}.',
    id: 'eEAT9A',
  },
  updatePaymentLink: {
    description: 'Link to open billing info modal',
    defaultMessage: 'Update Payment Method',
    id: '85g9Gm',
  },
  undoCancellation: {
    description: 'Undo cancellation link for users who have cancelled their accounts',
    defaultMessage: 'Undo Cancellation',
    id: '7YhecG',
  },
});

export default messages;
